import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import * as cardsSelectors from '../redux/selectors/cards.selectors'
import usePage from '../hooks/page.hook'
import * as filterSelectors from '../redux/selectors/filter.selectors'
import Card from '../components/Card'
import CardFilter from '../components/CardFilter'

import styles from '../styles/pages/pool.module.css' // fix
import useCardApi from '../API/card.api'
import useWorkerApi from '../API/worker.api'
import useCards from '../hooks/cards.hook'


function Pull() {
  const cardsList = useSelector(cardsSelectors.filter())
  const count = useMemo(() => cardsList.length, [cardsList])

  const [cards, setCards] = useState([])
  const { load } = useCards()

  const cardApi = useCardApi()
  const workerApi = useWorkerApi()

  const pagination = usePage(30, count)
  const page = pagination.page

  const triger = useSelector(filterSelectors.cardTriger)

  useEffect(() => {
    const { begin, end } = pagination.getRange()

    setCards(cardsList.slice(begin, end))
  }, [page, triger, cardsList])

  const [conversion, setConversion] = useState(null)
  const [convStamp, setConvStamp] = useState(0)

  const conversionHandler = async () => {
      if(convStamp + 60 * 1000 > Date.now()) { return }

      const conversion = await workerApi.cardsConversion()
      if(conversion) { 
        setConversion(conversion) 
        setConvStamp(Date.now())
      }
  }

  const resetHandler = async () => { 
    await cardApi.resetAll() 
    load()
  }

  const resetTotalHandler = async () => { 
    await cardApi.resetTotalAll()
    load()
  }

  return (
    <div className='table'>
      <div className='d-flex'>
        <Link to="/add-card" className={styles.button_link}>Add new card</Link>
        <span className={styles.button_link} onClick={() => resetHandler()}>Reset count of all cards</span>
        <span className={styles.button_link} onClick={() => resetTotalHandler()}>Reset total of all cards</span>
      </div>


      <div>
        <div className={styles.main}>
          <div className={styles.top}>
            <CardFilter />
            <div onClick={() => conversionHandler()} className={styles.load}>LOAD</div>
          </div>

          <div className={styles.info}>
              <div>Card</div>
              <div>Desc</div>
              <div>Limits</div>
              <div>Partner</div>            
              <div>Priority</div>                      
              <div className={styles.status}>Status</div>
              <div className={styles.status}>Action</div>
              <div className={styles.status}>Conv</div>
              <div className={styles.date}>time</div>
          </div>

          <div className={styles.table}>
              {cards.map((card) => <Card card={card} conversion={conversion} key={card._id} />)}
          </div>

          <div className={styles.bottom}>
              <button className={`${styles.button} ${!pagination.isBack? styles.diactive : null}`} onClick={pagination.back}>
                  Previos
              </button>
              <button className={`${styles.button} ${!pagination.isNext? styles.diactive : null}`} onClick={pagination.next}>
                  Next
              </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Pull